import { ItemListOption } from '@/contexts/item-context-types';
import { ListOption } from '@/components/list-item';
import { useAdaptAndGroupVariantPacks } from './use-adapt-and-group-item-list-options';
import { useMemo } from 'react';
import { useVolumePromotionsContext } from '@/contexts/volume-promotions-context';
import { VolumePromotion } from '@/utils/volume-promotions-types';

export type PromotionListOption = ListOption<{
  item: ItemListOption | null;
  promotion: VolumePromotion;
}>;

export const usePromotionListOptions = (visibleUUIDs?: Set<string>) => {
  const adaptAndGroupVariantPacks = useAdaptAndGroupVariantPacks();
  const { promotions } = useVolumePromotionsContext();

  return useMemo(
    () =>
      promotions.reduce<PromotionListOption[]>((result, promotion) => {
        // Skip promotions without a marketing tile
        if (promotion.hideMarketingTile) {
          return result;
        }

        if (visibleUUIDs && !visibleUUIDs.has(promotion.uuid)) {
          return result;
        }

        let item: ItemListOption | null = null;
        if (promotion.promotedVariantPacks.length === 1) {
          const promotedVp = promotion.promotedVariantPacks[0];
          item = adaptAndGroupVariantPacks([promotedVp.variantPack])[0];

          if (item) {
            // Override item photo with promotion photos if they exist
            const promotionPhotoURLs = promotedVp.photoURLs ?? [];
            if (item.metadata && promotionPhotoURLs.length > 0) {
              item.metadata.photoURLs = [
                ...promotionPhotoURLs,
                ...item.metadata.photoURLs,
              ];
            }
          }
        }

        result.push({
          metadata: {
            item,
            promotion,
          },
          title: promotion.uuid,
          value: promotion.uuid,
        });

        return result;
      }, []),
    [adaptAndGroupVariantPacks, promotions, visibleUUIDs],
  );
};
